import {
  ActionType,
  BaseActionWidget,
  ClickResult,
  DialogViewActionWidget,
  querySearchWidgetByViewHandle,
  SPI,
  ViewActionTarget
} from '@kunlun/dependencies';

const fieldNames = ['markupOrganizationType', 'distributor', 'salesOffice'];

@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog],
    modules: ['deliAriesCorePlatform'],
    model: [
      'deli.aries.item.DeliAriesPlatformMarkupDetailItemTpl',
      'deli.aries.item.DeliAriesSellerMarkupDetailItemTpl'
    ]
  })
)
export class MarkupDetailItemTplExportWidget extends DialogViewActionWidget {
  protected async clickAction(...args: unknown[]): Promise<ClickResult> {
    if (this.rootHandle) {
      const searchWidget = querySearchWidgetByViewHandle(this.rootHandle);
      let filterData = {
        'markupDetailItemTplExportWidgetMark': 'MarkupDetailItemTplExportWidgetMark'
      };
      fieldNames?.forEach((fieldName) => {
        filterData[fieldName] = searchWidget?.formData[fieldName];
      });
      this.activeRecords?.unshift(filterData);
    }
    return await super.clickAction(args);
  }
}
